package com.appsyde.shared.modules.account.domain.model

data class CheckoutSession(
    val url: String,
    val sessionId: String
)
